<template>
    <div class="choose-group layout-sub-page" v-bind:class="{'layout-toppest' : !showPop}">
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="hideChooseGroup" v-bind:createFunc="clickCreate"></title-bar>
        <!--展示最近选的三个分组，没有就不展示-->
        <div v-if="recentGroupList.length > 0" class="choose-group-history">
            <span>最近选择分组：</span>
            <span v-for="gData in recentGroupList" :key="gData.id" class="choose-item" @click="clickGroupItem(gData)">{{gData.f_name}}</span>
        </div>
        <div class="choose-group-list" :class="{'choose-group-list-2' : recentGroupList.length == 0}">
            <!-- Todo:在选择分组页面不添加删除分组功能 -->
            <van-swipe-cell v-for="data in groupData" v-bind:id="data.id" :key="data.id" v-bind:class="'item-' + data.id" :on-close="onClose" v-bind:disabled="data.id == 0">
                <div class="choose-group-item" @click="clickGroupItem(data)">
                    {{data.f_name}}
                    <i v-show="data.choosed" class="iconfont icon-selected choose-group-icon"></i>
                </div>
                <template slot="right">
                    <span class="choose-gi-delete">删除</span>
                </template>
            </van-swipe-cell>
        </div>

        <van-dialog v-model="showCreate" title="新建分组" confirmButtonText='确定' v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" v-model="inputGroup" placeholder="请输入分组名字" maxlength="17" v-to-focus-choose-group-input='true' autofocus >
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { DOM } from '../../modules/dom'
import { UTILS } from '../../modules/utils'
import TitleBar from '../../components/TitleBar.vue'

export default {
    name: 'ChooseGroup',
    components: { TitleBar },
    directives : {
        "to-focus-choose-group-input" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    computed: {
        gotGroupData() {
            return this.$store.state.group.gotGroupData;
        },
        chooseId() {
            return this.$store.state.group.chooseId;
        },
        groupData(){
            return this.$store.state.group.groupData;
        },
        recentGroupList() {
            return this.$store.state.group.recentGroupList;
        },
        chooseGroupFromPage() {
            return this.$store.state.collate.chooseGroupFromPage;
        }
    },
    mounted: function() {
        // 特殊处理分享页面内编辑分组时的选择分组页的z-index值
        var me = this;
        var curPath = this.$router.history.current.path;
        var curStyle = this.$el.style.cssText;
        // 动态设置页面的宽高
        setTimeout(() => {
            me.$el.style.width = innerWidth + 'px';
            me.$el.style.height = innerHeight + 'px';
            // 分享页面设置zindex值
            if(curPath.indexOf('share') != -1){
                me.$el.style.zIndex = 3000;
            }
        }, 100);
    },
    created: function() {
        // 默认拉取分组数据
        this.$store.dispatch('group/initGroupList');
        var checkedGroup = this.$store.state.group.checkedGroup;
        if(!checkedGroup) {
            this.$store.dispatch('group/initGroupDefaultData');
        }
        let groupList = window.localStorage.getItem('H5_Fate_GroupList');
            groupList = groupList && groupList != '' ? JSON.parse(groupList) : [];
        this.$store.state.group.recentGroupList = [].concat(groupList);
    },
    data(){
        return {
            inputGroup: '',
            showCreate: false,
            showPop: false,
            titleData: {'titleText': '选择分组', 'titleCreate': '新建', 'showCancel': false},
        }
    },
    methods:{
        hideChooseGroup() {
            var curPath = this.$router.history.current.path, newPath = '';
            console.log('choosegroup----------', curPath);
            if(curPath.indexOf('/edit') != -1) {
                newPath = curPath.replace('/choosegroup', '');
                this.$router.replace(newPath);
                return;
            }
            // 从首页过来的页面
            if(curPath.indexOf('/collate') != -1) {
                if(curPath.indexOf('/detail') != -1) {
                    newPath = curPath.replace('/choosegroup', '');
                    this.$router.replace(newPath);
                    return;
                }
                if(curPath.indexOf('/discuss') != -1) {
                    this.$router.go(-1);
                    return;
                }
                if(this.chooseGroupFromPage == '') {
                    this.$router.replace('/collate');
                }else {
                    this.$router.replace(this.chooseGroupFromPage);
                }
                DOM.showPageByClassName('collate-page');
            }else if(curPath.indexOf('/share') != -1 || curPath.indexOf('/choosecreate') != -1 || curPath.indexOf('/calendar') != -1) {
                newPath = curPath.replace('/choosegroup', '');
                if(curPath.indexOf('embedded/famouspediaread') != -1) {
                    curPath = this.$router.history.current.fullPath;
                    newPath = curPath.replace('famouspediaread/choosegroup', 'famouspediaread')
                }else if(curPath.indexOf('embedded/famouspediacreate') != -1) {
                    curPath = this.$router.history.current.fullPath;
                    newPath = curPath.replace('famouspediacreate/choosegroup', 'famouspediacreate')
                }
                this.$router.replace(newPath);
            }else if(curPath.indexOf('/famouspediaread') != -1){
                newPath = curPath.replace('/choosegroup', '');
                this.$router.replace(newPath);
                DOM.showPageByClassName('famous-pedia-create-form');
                DOM.showPageByClassName('famous-comment-bottom-bar');
            }else if(curPath.indexOf('/getbzselect') != -1) {
                newPath = curPath.replace('/choosegroup', '');
                this.$router.replace(newPath);
            }else if(curPath.indexOf('/discuss') != -1 && curPath.indexOf('discussmain') != -1) {
                this.$router.go(-1);
            }
        },
        clickGroupItem(data) {
            if(data.id == this.chooseId){
                this.hideChooseGroup();
                return;
            }
            var index = UTILS.getIdIndexInObjectArray(this.groupData, data.id);
            var chooseIndex = UTILS.getIdIndexInObjectArray(this.groupData, this.chooseId);
            this.$set(this.groupData[index], 'choosed', true);

            // console.error('clickGroupItem---------', this.chooseId, chooseIndex)
            if(this.groupData[chooseIndex]){
                this.$set(this.groupData[chooseIndex], 'choosed', false);
            }
            this.$store.state.group.chooseId = data.id;
            this.$store.state.group.choosedGroup = data;
            this.$store.dispatch('group/updateRecentGroupList', data);

            // 将当前选中的分组，保存到ls
            var newTime = parseInt((new Date()).getTime());
            localStorage.setItem('H5_Fate_NewGroup', data.id);
            localStorage.setItem('H5_Fate_NewGroupTime', newTime)

            this.hideChooseGroup();

            // 处理编辑页面的逻辑
            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('edit') != -1) {
                this.$store.dispatch('edit/updateEditDetail', 'group');
            }
            // 处理命盘分享页面的逻辑
            if(curPath.indexOf('share/detail') != -1){
                this.$store.dispatch('share/updateDetailShareSavePop', data);
            }
            // 处理批盘分享页面的逻辑
            if(curPath.indexOf('share/comment') != -1){
                this.$store.dispatch('othershare/updateShareFormData', data);
            }
            // 处理论盘分享页面的逻辑
            if(curPath.indexOf('share/discuss') != -1){
                this.$store.dispatch('othershare/updateShareFormData', data);
            }
            // 处理百科阅读页面的逻辑
            if(curPath.indexOf('/famouspediaread') != -1) {
                this.$store.dispatch('famouspedia/updateBaikeBaziFormData', data);
            }
            // 处理日历[即使起盘]的逻辑
            if(curPath.indexOf('/00000') != -1) {
                this.$store.dispatch('calendar/updateCalendarFormData', data);
            }
            // 处理论盘页面保存论盘的逻辑
            if(curPath.indexOf('/discuss/discussmain') != -1 || curPath.indexOf('/discuss/collate') != -1) {
                this.$store.state.discuss.discussFormData.group = data.f_name;
                this.$store.state.discuss.discussFormData.groupId = data.id;
            }
        },
        clickCreate() {
            this.showCreate = true;
            this.inputGroup = this.baseWord;
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if(this.inputGroup != this.baseWord && this.inputGroup != ''){
                    this.$store.dispatch('group/addGroup', this.inputGroup);
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },
        // clickPosition 表示关闭时点击的位置
        onClose(clickPosition, instance) {
            var me = this;
            switch (clickPosition) {
                case 'cell':
                    instance.close();
                    break;
                case 'right':
                    this.showPop = true;
                    this.$dialog.confirm({
                        message: '确定删除吗？'
                    }).then(() => {
                        var id = instance.$el.id;
                        var index = UTILS.getIdIndexInObjectArray(this.groupData, id);
                        console.log('delete------', id, index, this.groupData[index])
                        // 注:当前删除的正好是当前选中的分组的话，重置选中的分组
                        if(this.groupData[index]['choosed']){
                            this.groupData[index]['choosed'] = false;
                            this.resetChoosedGroup();
                        }
                        this.$store.dispatch('group/deleteGroup', {
                            groupId: id,
                            sucCb: function() {
                                me.showPop = false;
                                setTimeout(() => {
                                    window.scrollTo(0, 0)
                                }, 20);
                            },
                            failCb: function(code) {
                                if(code == 9101) {
                                    me.$toast('当前分组有数据，不能被删除。 \n 请前往记录列表的"分组管理"进行操作。')
                                }
                            }
                        });
                        instance.close();
                    }).catch(() => {
                        me.showPop = false;
                        setTimeout(() => {
                            window.scrollTo(0, 0)
                        }, 20);
                        instance.close();
                    }); ;
                break;
            }
        },
        resetChoosedGroup() {
            var newId = 0;
            var index = UTILS.getIdIndexInObjectArray(this.groupData, newId);
            this.$store.state.group.chooseId = newId;
            this.$store.state.group.choosedGroup = this.groupData[index];
            this.groupData[index]['choosed'] = true;
        }
    }
}
</script>